import QueryCredits from "graphql/queries/QueryCredits";
import QueryEmployeeCreditAmounts from "graphql/queries/QueryEmployeeCreditAmounts";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder';

const FetchCreditAmounts = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'employee_credit_amounts', QueryEmployeeCreditAmounts, {
			resultPath: [ 'employee_me', 'credit_amounts' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchCreditAmounts
